import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyLink, meetingViewershipLink } from './links.js';
import { meetingStatusValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'meeting_viewership.duration_minutes': {
        aggregations: ['avg'],
        label: 'Meeting Duration (Minutes)',
        type: 'number',
    },
};
/**
 * Combination data source: Meetings x Streaming Records.
 * Recording availability and media analytics per meeting. Tracks which meetings
 * have recordings, playback status, and recording duration.
 */
export const meetingViewershipCube = {
    category: 'Meetings',
    description: 'Meeting recordings and media analytics including availability, playback status, and duration.',
    label: 'Meeting Viewership & Recordings',
    requiredModule: 'hasRecord',
    measures: {
        'meeting_viewership.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'meeting_viewership.sum_agenda_item_count': { label: 'Total Agenda Items', type: 'number' },
    },
    dimensions: {
        ...aggregatableDimensions,
        // Meeting
        'meeting_viewership.has_video': { label: 'Has Video', type: 'boolean' },
        'meeting_viewership.is_private': { label: 'Is Private', type: 'boolean' },
        'meeting_viewership.location': { label: 'Location', type: 'string' },
        'meeting_viewership.status': {
            label: 'Meeting Status',
            type: 'string',
            valueLabels: meetingStatusValueLabels,
        },
        'meeting_viewership.title': {
            label: 'Meeting Title',
            link: meetingViewershipLink,
            type: 'string',
        },
        // Recording
        'media_archives.duration_minutes': { label: 'Recording Duration (Minutes)', type: 'number' },
        'media_archives.has_playback': { label: 'Has Playback', type: 'boolean' },
        'media_archives.has_thumbnail': { label: 'Has Thumbnail', type: 'boolean' },
        // Meeting Body
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    },
    timeDimensions: {
        'media_archives.created_at': { label: 'Recording Created At', type: 'date' },
        'meeting_viewership.date': { label: 'Meeting Date', type: 'date' },
    },
};
